import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Localidad } from '../../../modules/rutas/models/localidad.model';

export function localidadValida(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    return typeof value === 'object' && 'codigo' in value
      ? null
      : { localidadInvalida: true };
  };
}

export function requireObject(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  if (!value) return { required: true };
  if (typeof value === 'string') return { invalidSelection: true };
  return null;
}
